import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {config} from 'rxjs';

@Component({
  selector: 'app-project-slab',
  templateUrl: './project-slab.component.html',
  styleUrls: ['./project-slab.component.scss']
})
export class ProjectSlabComponent implements OnInit, AfterViewInit {

  constructor() { }

  @ViewChild('mainContainer', {static: true}) mainContainer: ElementRef;
  @ViewChild('infoContainer', {static: true}) infoContainer: ElementRef;

  @Input() config: {
    animation: string;
    id: string;
    para1?: string;
    para2?: string;
    infoTitle?: string;
    src: string,
    dir?: string;
    btnLink?: string;
    btnText?: string;
  };

  ngOnInit() {
  }

  ngAfterViewInit() {

  }

  openLink(projectConfig) {
    window.open(projectConfig.btnLink, '_blank');
  }
}
